<template>
<div class="index is-search" :style="{paddingTop: $store.state.headerHeight + 'px'}" v-loading="pageLoading">
  <SubHeader :showUser="true" :showNav="false"></SubHeader>
  <div class="index-vip" style="display: none;" v-if="plat!=120 && !vipInfo.is_buy" @click="toVIP">
    <!-- 不是会员1 -->
    <div class="btn">
        开通会员
      </div>
  </div>
  <div class="index-vip2" v-else-if="plat != 120" style="display: none;"  @click="toVIP">
    <!-- 是会员 -->
    <div class="content">
      <b>尊敬的会员用户</b>
      您的会员有效期到{{vipInfo.end_time}}
    </div>
    <div class="btn">
      立即续费
    </div>
  </div>
  <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white" v-if="swiperData.length">
    <van-swipe-item v-for="item in swiperData" :key="item.id">
      <img :src="item.cover" @click="toPage(item.url)"/>
    </van-swipe-item>
  </van-swipe>
  <!-- <div class="part-title"  v-if="list">
    <div class="part-title_text" >全国托育服务技能大赛培训班</div>
  </div>
  <div v-if="list && list.list">
    <PriceCardImgBig v-for="(item, i) of list.list.slice(0,1)"  :key="i" :index="i" :cardData="item" :hideStudy="true"></PriceCardImgBig>
  </div> -->
  <div class="quality" v-if="listFL && listFL.list && listFL.list.length && !pageLoading">
    <div class="part-title">
      <div class="part-title_text">托育相关政策法规培训</div>
      <p @click="toList(208)">查看更多 <van-icon name="arrow" size="12" color="#231815"/></p>
    </div>
    <div class="list12">
      <div v-for="(item, index) of listFL.list" :key="index" >
        <PriceCardjn :index="index" :cardData="item"  @click.native="goDetail(item.id)" type="demonstrate"></PriceCardjn>
      </div>
    </div>
    <div class="line"></div>
  </div>
  <div class="quality" v-if="lessonList3 && lessonList3.list && lessonList3.list.length && !pageLoading">
    <div class="part-title">
      <div class="part-title_text" >托育机构负责人培训</div>
    </div>
    <PriceCard :hidePrice="true" :desShow="true" v-for="(item, i) of lessonList3.list.slice(0,2)" @click.native="goDetail(item.id)" :key="i" :index="i" :cardData="item"></PriceCard>
  </div>
  <div class="quality" v-if="lessonList4 && lessonList4.list && lessonList4.list.length && !pageLoading">
    <div class="part-title">
      <div class="part-title_text" >托育机构保育人员培训</div>
    </div>
    <PriceCardImgBig btnText="立即学习" v-for="(item, i) of lessonList4.list.slice(0,1)"  :key="i" :index="i" :cardData="item"></PriceCardImgBig>
  </div>
  <div class="quality" v-if="listZZ && listZZ.list && listZZ.list.length && !pageLoading">
    <div class="part-title">
      <div class="part-title_text">托育机构岗位职责培训</div>
      <p @click="toList(207)">查看更多 <van-icon name="arrow" size="12" color="#231815"/></p>
    </div>
    <div class="list12">
      <div v-for="(item, index) of listZZ.list" :key="index" >
        <PriceCardjn :index="index" :cardData="item"  @click.native="goDetail(item.id)" type="demonstrate"></PriceCardjn>
      </div>
    </div>
    <div class="line"></div>
  </div>
  <div class="quality" v-if="lessonList1 && lessonList1.list && lessonList1.list.length && !pageLoading">
    <div class="part-title">
      <div class="part-title_text" >机构负责人技能提升培训</div>
    </div>
    <PriceCardImgBig btnText="立即学习" v-for="(item, i) of lessonList1.list.slice(0,1)"  :key="i" :index="i" :cardData="item"></PriceCardImgBig>
  </div>
  <div class="quality" v-if="lessonList2 && lessonList2.list && lessonList2.list.length && !pageLoading">
    <div class="part-title">
      <div class="part-title_text" >保育人员技能提升培训</div>
    </div>
    <PriceCardImgBig btnText="立即学习" v-for="(item, i) of lessonList2.list.slice(0,1)"  :key="i" :index="i" :cardData="item"></PriceCardImgBig>
  </div>
 
  
  <div class="quality" v-if="sxList && sxList.list && sxList.list.length">
    <div class="part-title" v-if="!pageLoading">
      <div class="part-title_text">托育服务技能实训</div>
      <p @click="toList(226)">查看更多 <van-icon name="arrow" size="12" color="#231815"/></p>
    </div>
    <PriceCard :hidePrice="true"  :key="index" v-for="(item, index) of sxList.list" :desShow="true" :index="index" :cardData="item"  @click.native="goDetail(item.id)" type="demonstrate"></PriceCard>
    <div class="line"></div>
  </div>
   <!-- 职业认证 -->
   <div class="quality" v-if="jnLesson && jnLesson.list && jnLesson.list.length">
    <div class="part-title" v-if="!pageLoading">
      <!-- <img src="https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/H5/%E6%8E%A8%E8%8D%90%402x.png"/> -->
      <div class="part-title_text">托育从业人员职业发展</div>
      <p @click="toList(122)">查看更多 <van-icon name="arrow" size="12" color="#231815"/></p>
    </div>
    <div class="list12">
      <div v-for="(item, index) of jnLesson.list" :key="index" >
        <PriceCardjn :index="index" :cardData="item"  @click.native="goDetail(item.id)" type="demonstrate"></PriceCardjn>
      </div>
    </div>
    <div class="line"></div>
  </div>
  <div class="quality" v-if="yyList2.length && !pageLoading">
    <div class="part-title">
      <div class="part-title_text">托育服务专项培训</div>
      <p @click="toList(163)">查看更多 <van-icon name="arrow" size="12" color="#000"/></p>
    </div>
      <div class="tabList2">
          <p :class="{active:yyList2Index == index}" v-for="(item, index) in yyList2" :key="index" @click="yyList2Index = index"> {{ item.name }}</p>
      </div>
      <PriceCard :hide-price="true" btn-text="立即学习" v-for="(v, i) of yyList2[yyList2Index].list[0].slice(0,3)"  :key="i"   @click.native="goDetail(v.id)" :index="yyList2Index" :cardData="v"></PriceCard>
  </div>
  <!-- 国培 -->
  
  <div class="quality" v-if="liveData.length" style="padding-bottom:20px" >
    <div class="part-title" v-if="!pageLoading">
      <div class="part-title_text">往期直播</div>
      <div class="part-title_more" @click="goList('live')">查看更多></div>
    </div>
    <LiveCard v-for="(item, index) of liveData[0].data.slice(0,4)" :key="index" :index="index" :cardData= "item"></LiveCard>
  </div>
  <div class="bottom">—   到底了…  —</div>
</div>
</template>

<script>
import PriceCard from "@/components/PriceCard";
import PriceCardImgBig from "@/components/PriceCardImgBig";
import VideoCard from "@/components/VideoCard";
import TopCard from "@/components/TopCard";
import SubHeader from "@/components/SubHeaderYingyou";
import SubFooter from "@/components/SubFooter";
import LiveCard from "@/components/LiveCard";
import ideaList from "@/components/ideaList";
import PriceCardjn from "@/components/PriceCard1-3";
import { resolve } from "path";
import { Toast } from "vant";

// import Vue from 'vue'
// import VConsole from 'vconsole';
// Vue.prototype.Vconsole = new VConsole()

export default {
  components: {
    PriceCardjn,
    PriceCard,
    VideoCard,
    TopCard,
    SubHeader,
    SubFooter,
    LiveCard,
    PriceCardImgBig,
    ideaList
  },
  computed: {
    titleName() {
      return this.$store.state.plat.name;
    },
    plat() {
      return this.$store.state.plat_id;
    },
  },
  data() {
    return {
      pageLoading: true,
      swiperData: [],
      menuData: [],
      liveData: [],
      vipInfo:{},

      lessonList1:[],
      lessonList2:[],
      lessonList3:[],
      lessonList4:[],

      jnLesson: [],
      yyList2:[],//岗位技能培训
      yyList2Name: '',
      yyList2Index: 0,
      listFL:[],//法律
      listZZ:[],//
      sxList:null,
      list:null, //全国托育服务技能大赛培训班
    };
  },
  async mounted() {
    this.init();
  },
  methods: {
   
    will() {
      this.$toast('敬请期待');
    },

    async init() {
      if(this.$until.isWeiXin()=='wxapp' && this.$route.query.phone){
        await this.$request.mobileLogin({
               mobile:this.$route.query.phone
             })
      }
      let res = await this.$api({
        url: `/api/platform/university/index`,
        data:{
          plat_id: this.plat,
          terminal: 1,
          is_interior: 2
        }
      });
      this.pageLoading = false;
      if (res.code == 0) {
        let {
          category_list,
          banner,
          live_stream,
          plat_vip,
        } = res.data;
        this.menuData = category_list || [];
        this.swiperData = banner;
        this.liveData = live_stream;
        this.vipInfo = plat_vip;
        this.pageLoading = false;

        // 职业能力认证
        let jnLesson = this.menuData.find((item) => item.id == '122');
        if(jnLesson){
          this.jnLesson = {
            id: jnLesson.id,
            name: jnLesson.name,
            list:jnLesson.list.map(item=>item.list[0]).flat().slice(0,4)
          }
        }
        // VIP
        this.yyList2 = this.menuData.find((item) => item.id == 163).list;
        this.yyList2Name =  this.menuData.find((item) => item.id == 163).name;

        
        // 托育机构负责人能力提升培训
        let lessonList1 = this.menuData.find((item) => item.id == '228');
        if(lessonList1){
          this.lessonList1 = {
            id: lessonList1.id,
            name: lessonList1.name,
            list:lessonList1.list.map(item=>item.list[0]).flat().slice(0,2)
          }
        }
        // 托育机构保育人员能力提升
        let lessonList2 = this.menuData.find((item) => item.id == '229');
        if(lessonList2){
          this.lessonList2 = {
            id: lessonList2.id,
            name: lessonList2.name,
            list:lessonList2.list.map(item=>item.list[0]).flat().slice(0,2)
          }
        }
        // 托育机构负责人
        let lessonList3 = this.menuData.find((item) => item.id == '230');
        if(lessonList3){
          this.lessonList3 = {
            id: lessonList3.id,
            name: lessonList3.name,
            list:lessonList3.list.map(item=>item.list[0]).flat().slice(0,2)
          }
        }
        console.log(this.lessonList3)
        // 托育机构保育人
        let lessonList4 = this.menuData.find((item) => item.id == '231');
        if(lessonList4){
          this.lessonList4 = {
            id: lessonList4.id,
            name: lessonList4.name,
            list:lessonList4.list.map(item=>item.list[0]).flat().slice(0,2)
          }
        }
        // 全国托育服务技能大赛培训班
        let list = this.menuData.find((item) => item.id == '225');
        if(list){
          this.list = {
            id: list.id,
            name: list.name,
            list:list.list.map(item=>item.list[0]).flat().slice(0,2)
          }
        }

        // 法律
        let listFL = this.menuData.find((item) => item.id == '208');
        if(listFL){
          this.listFL = {
            id: listFL.id,
            name: listFL.name,
            list:listFL.list.map(item=>item.list[0]).flat().slice(0,4)
          }
        }
        let listZZ = this.menuData.find((item) => item.id == '207');
        if(listZZ){
          this.listZZ = {
            id: listZZ.id,
            name: listZZ.name,
            list:listZZ.list.map(item=>item.list[0]).flat().slice(0,4)
          }
        }
        let sxList = this.menuData.find((item) => item.id == '226');
        if(sxList){
          this.sxList = {
            id: sxList.id,
            name: sxList.name,
            list:sxList.list.map(item=>item.list[0]).flat().slice(0,4)
          }
        }
        // this.$store.commit('SET_VIP',plat_vip)
      } else {
        this.$toast(res.msg);
      }
    },
    toPage(url){
      if(url) window.location.href = url
    },
    goDetail(id) {
      let url = `./detailYingyou?id=${id}`
     
      this.$router.push(url);
    },
    toList(id){
      this.$router.push(`./lessonYingyou?id=${id}`);
    },
    goList(type) {
      this.$router.push(`./${type}`);
    },
    toVIP(){
      if(!localStorage.getItem('token')){
        this.$dialog.confirm({
          title: '提示',
          message: '请登录后查看',
          confirmButtonText:'立即登录',
        })
          .then(() => {
            // on confirm
            this.$router.push('./login/phone')
          })
          .catch(() => {
            // on cancel
          });
      }else{
        this.$router.push({
          path:'./vip/detailVIP',
          query:{
            id:this.vipInfo.goods_id
          }
        })
      }
    }
  },
};
</script>

<style lang="scss" scoped>

  .my-swipe{
    width: 690px;
    margin: 10px auto 0;
    img{
      width: 100%;
      border-radius: 10px;
    }
  }
  .index-vip {
    width: 690px;
    height: 172px;
    margin: 23px auto 18px;
    display: block;
    background: url('https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/gaoyanyuan/vip.png') no-repeat;
    background-size: 100%;
    position: relative;
  }
 
  .index-vip2 {
    width: 690px;
    height: 172px;
    margin: 23px auto 18px;
    display: block;
    background: url('https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/isVipBg.png') no-repeat;
    background-size: 100%;
    position: relative;
  }
  .index-vip2 .content{
  position: absolute;
  left:30px;
  top:40px;
  color: #6a4a2c;
  font-size: 24px;
}
.index-vip2 .content b{
  display: block;
  font-weight: bold;
  font-size: 34px;
  margin-bottom: 15px;
}
.index-vip
 .btn, .index-vip2 .btn {
  position: absolute;
  bottom: 37px;
  right: 37px;
  width: 155px;
  height: 56px;
  background: #6a4a2c;
  border-radius: 28px;
  text-align: center;
  line-height: 56px;
  color: #fff;
  font-size: 26px;
}
.index {
  min-height: 100vh;
  overflow: hidden;
}

.is-search {
  padding-top: 100px;
  box-sizing: border-box;
}

.tab-class {
  color: #333;
  font-size: 30px;
}

.tab-warp {
  // height: calc(100vh - 88px - 96px);
  padding-bottom: 10px;
}

.tab-list {
  // height: calc(100vh - 88px - 96px);
  padding: 30px 0 0;
  box-sizing: border-box;
  overflow: hidden;
}

.swiper-wrap {
  width: 690px;
  height: 270px;
  margin: 11px auto 0;
  overflow: hidden;
  background: #fff;
  position: relative;
}

.swiper {
  height: 100%;
  width: 100%;
}

.swiper-item {
  display: block;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  text-align: center;
  border-radius: 12px;
}

.page {
  position: absolute;
  right: 19px;
  bottom: 14px;
  color: #fff;
  font-size: 24px;
  letter-spacing: 2px;
  height: 40px;
  line-height: 40px;
  padding: 0 18px;
  border-radius: 20px;
  background: rgba(0, 0, 0, 0.2);
}

.menu {
  width: 100vw;
  display: flex;
  align-items: center;
  padding: 0 5px;
  flex-wrap: wrap;

  .item {
    flex: 0 1 148px;
    width: 148px;
    text-align: center;
    margin-top: 40px;
  }

  .icon {
    width: 78px;
    height: 78px;
    display: inline-block;
    margin-bottom: 10px;
  }

  .name {
    font-size: 24px;
    color: #333333;
    line-height: 33px;
  }

  .line {
    width: 690px;
    height: 2px;
    background: #eee;
    margin: 34px auto 10px;
  }
}

.quality {
  width: 100vw;
  background-color: #fff;
  margin-top: 24px;
  overflow: hidden;
  .quality-list {
    width: 100%;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }
}
.part-title{
    display: flex;
    align-items: center;
    padding: 26px 30px 40px;
    >img{
      width: 36px;
      margin-right: 10px;
    }
    .part-title_text{
      flex: 1;
      font-weight: 600;
      color: #333;
      font-size: 36px;
    }
    p{
      color: #888;
      font-size: 28px;
    }
  }
  .tabList2{
    padding-top: 10px;
    padding-left: 30px;
    margin-bottom: 36px;
    box-sizing: border-box;
    width: 100%;
    white-space: nowrap;
    overflow-x: scroll;
    &::-webkit-scrollbar{
      height: 0 !important;
    }
   -ms-overflow-style: none;
   overflow: -moz-scrollbars-none;
    p{
      display: inline-block;
      padding: 0 16px;
      border-radius: 24px;
      height: 58px;
      line-height: 48px;
      background: #fff;
      margin-right: 20px;
      font-size: 32px;
      color: #4B4E5E;
      font-weight: 400;
      line-height: 45px;
    }
    p.active{
      color: #144094;
      font-size: 34px;
      font-weight: 500;
      position: relative;
      &::after{
        position: absolute;
        content: '';
        display: block;
        width: 36px;
        height: 6px;
        background: #144094;
        border-radius: 3px;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
      }
    }
    
  }
</style>
